'use client'
import { jsx } from 'react/jsx-runtime';
import { MergeUserAccountsConflictsView } from './MergeUserAccountsConflictsView/MergeUserAccountsConflictsView.js';
import { AccountExistsView } from './AccountExistsView/AccountExistsView.js';
import { BridgeNextWalletConnectionView } from './BridgeNextWalletConnectionView/BridgeNextWalletConnectionView.js';
import { BridgeSummaryView } from './BridgeSummaryView/BridgeSummaryView.js';
import { BridgeWelcomeView } from './BridgeWelcomeView/BridgeWelcomeView.js';
import { CaptchaVerifyUser } from './CaptchaVerifyUser/CaptchaVerifyUser.js';
import { CoinbaseMPCClaimIntro } from './CoinbaseMPCClaimIntro/CoinbaseMPCClaimIntro.js';
import { CollectUserDataView } from './CollectUserDataView/CollectUserDataView.js';
import { CollectUserDataViewNoWallet } from './CollectUserDataViewNoWallet/CollectUserDataViewNoWallet.js';
import { CreatePasswordView } from './CreatePasswordView/CreatePasswordView.js';
import { EmailConfirmationWaitingView } from './EmailConfirmationWaitingView/EmailConfirmationWaitingView.js';
import { EmailVerification } from './EmailVerification/EmailVerification.js';
import { EmailWalletOTPVerificationView } from './EmailWalletOTPVerificationView/EmailWalletOTPVerificationView.js';
import { EmbeddedRevealView } from './EmbeddedReveal/EmbeddedRevealView/EmbeddedRevealView.js';
import { FarcasterConnectView } from './FarcasterConnectView/FarcasterConnectView.js';
import { LoginView } from './LoginView/LoginView.js';
import { MergeUserAccountsWithSameEmailView } from './MergeUserAccountsWithSameEmailView/MergeUserAccountsWithSameEmailView.js';
import { MergeUserAccountsView } from './MergeUserAccountsView/MergeUserAccountsView.js';
import { MfaChooseDeviceView } from './MfaChooseDeviceView/MfaChooseDeviceView.js';
import { MfaSecureDeviceView } from './MfaSecureDeviceView/MfaSecureDeviceView.js';
import { NetworkNotSupported } from './NetworkNotSupported/NetworkNotSupported.js';
import { NetworkNotSupportedSwitchManual } from './NetworkNotSupportedSwitchManual/NetworkNotSupportedSwitchManual.js';
import { NoAccess } from './NoAccess/NoAccess.js';
import { NoQrNotInstalledView } from './NoQrNotInstalledView/NoQrNotInstalledView.js';
import { AccessBlockedView } from './AccessBlockedView/AccessBlockedView.js';
import { PasskeyIntroView } from './Passkey/PasskeyIntroView/PasskeyIntroView.js';
import { AddRecoveryEmail } from './Passkey/PasskeyRecovery/AddRecoveryEmail/AddRecoveryEmail.js';
import { PasskeyBundleRecovery } from './Passkey/PasskeyRecovery/BundleValidation/PasskeyBundleRecovery.js';
import { PasskeyCompleteRecovery } from './Passkey/PasskeyRecovery/CompleteRecovery/PasskeyCompleteRecovery.js';
import { PasskeyInitRecovery } from './Passkey/PasskeyRecovery/InitRecovery/PasskeyInitRecovery.js';
import { RenamePasskeyView } from './Passkey/RenamePasskeyView/RenamePasskeyView.js';
import { EmbeddedAuthChoice } from './Passkey/EmbeddedAuthChoice/EmbeddedAuthChoice.js';
import 'react-i18next';
import '../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../components/Alert/Alert.js';
import 'react';
import '../events/dynamicEvents.js';
import '../../../_virtual/_tslib.js';
import '@dynamic-labs/utils';
import '../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import '../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../utils/constants/colors.js';
import '../utils/constants/values.js';
import '../store/state/loadingAndLifecycle.js';
import '../shared/consts/index.js';
import '../context/CaptchaContext/CaptchaContext.js';
import '../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../config/ApiEndpoint.js';
import '../store/state/user/user.js';
import '../locale/locale.js';
import '../store/state/projectSettings/projectSettings.js';
import '../context/AccessDeniedContext/AccessDeniedContext.js';
import '../context/AccountExistsContext/AccountExistsContext.js';
import '../context/UserWalletsContext/UserWalletsContext.js';
import '../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../context/WalletContext/WalletContext.js';
import '../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import '../context/ThemeContext/ThemeContext.js';
import '../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '@dynamic-labs/types';
import '../context/LoadingContext/LoadingContext.js';
import 'yup';
import '../context/MockContext/MockContext.js';
import './CollectUserDataView/useFields.js';
import '../context/FieldsStateContext/FieldsStateContext.js';
import '../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../store/state/environmentId.js';
import '../store/state/walletConnectorOptions.js';
import '../context/FooterAnimationContext/index.js';
import '../components/ShadowDOM/ShadowDOM.js';
import '../components/Transition/ZoomTransition/ZoomTransition.js';
import '../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../components/Transition/OpacityTransition/OpacityTransition.js';
import '../components/OverlayCard/OverlayCardTarget/OverlayCardTarget.js';
import '../context/SocialRedirectContext/SocialRedirectContext.js';
import '../context/WalletGroupContext/WalletGroupContext.js';
import '../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'react-focus-lock';
import '../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../components/IconButton/IconButton.js';
import '../components/MenuList/Dropdown/Dropdown.js';
import 'formik';
import '../store/state/sendBalances.js';
import '../components/Input/Input.js';
import './TransactionConfirmationView/helpers/transactionErrorMessage.js';
import '../context/PasskeyContext/PasskeyContext.js';
import '../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../index.js';
import '../store/state/tokenBalances.js';
import '../components/InlineWidget/InlineWidget.js';
import '../components/IsBrowser/IsBrowser.js';
import '../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../components/Popper/Popper/Popper.js';
import '../components/Popper/PopperContext/PopperContext.js';
import 'qrcode';
import { PendingSignatureView } from './PendingSignatureView/PendingSignatureView.js';
import { QrCodeView } from './QrCodeView/QrCodeView.js';
import { WalletList } from './WalletList/WalletList.js';
import { PendingConnectView } from './PendingConnectView/PendingConnectView.js';
import { SelectHardwareWalletView } from './SelectHardwareWalletView/SelectHardwareWalletView.js';
import { SelectWalletInWalletGroupView } from './SelectWalletInWalletGroupView/SelectWalletInWalletGroupView.js';
import { SmsVerification } from './SmsVerification/SmsVerification.js';
import { SocialRedirectView } from './SocialRedirectView/SocialRedirectView.js';
import { SocialWrongAccountView } from './SocialWrongAccountView/SocialWrongAccountView.js';
import { WalletCannotBeTransferredView } from './WalletCannotBeTransferredView/WalletCannotBeTransferredView.js';
import { WalletGroupView } from './WalletGroupView/WalletGroupView.js';
import { WalletLockedView } from './WalletLockedView/WalletLockedView.js';
import { WalletRedirectView } from './WalletRedirectView/WalletRedirectView.js';
import { WalletSignSpinnerView } from './WalletSignSpinnerView/WalletSignSpinnerView.js';
import { WalletUsedView } from './WalletUsedView/WalletUsedView.js';
import { MfaDisplayBackupCodesView } from './MfaDisplayBackupCodesView/MfaDisplayBackupCodesView.js';
import { MfaVerificationView } from './MfaVerificationView/MfaVerificationView.js';
import { MfaRecoveryView } from './MfaRecoveryView/MfaRecoveryView.js';
import { MfaSecureDeviceHelper } from './MfaSecureDeviceHelpView/MfaSecureDeviceHelpView.js';
import { SandboxMaximumThresholdReached } from './SandboxMaximumThresholdReached/SandboxMaximumThresholdReached.js';
import { GlobalWalletConfirmView } from './GlobalWalletConfirmView/GlobalWalletConfirmView.js';
import { GlobalWalletInfoView } from './GlobalWalletInfoView/GlobalWalletInfoView.js';
import { GlobalWalletMaliciousView } from './GlobalWalletMaliciousView/GlobalWalletMaliciousView.js';
import { PasskeyNewDomainDetectedView } from './Passkey/PasskeyNewDomainDetectedView/PasskeyNewDomainDetectedView.js';

const viewToComponentMap = {
    'access-blocked': AccessBlockedView,
    'account-exists': AccountExistsView,
    'bridge-next-wallet-connection': BridgeNextWalletConnectionView,
    'bridge-summary': BridgeSummaryView,
    'bridge-welcome': BridgeWelcomeView,
    captcha: CaptchaVerifyUser,
    'chainalysis-blocked-wallet': NoAccess,
    'collect-user-data': CollectUserDataView,
    'collect-user-data-login-no-wallet': CollectUserDataViewNoWallet,
    'create-password-view': CreatePasswordView,
    'email-wallet-otp-verification-view': EmailWalletOTPVerificationView,
    'embedded-reveal-account-view': EmbeddedRevealView,
    'embedded-reveal-view': EmbeddedRevealView,
    'embedded-wallet-auth-choice': EmbeddedAuthChoice,
    'farcaster-connect-view': FarcasterConnectView,
    'gate-blocked-wallet': NoAccess,
    'global-wallet-confirm': GlobalWalletConfirmView,
    'global-wallet-info': GlobalWalletInfoView,
    'global-wallet-malicious': GlobalWalletMaliciousView,
    'login-with-email-or-wallet': LoginView,
    'login-with-email-or-wallet-full-wallet-list': WalletList,
    'login-with-email-verification': EmailVerification,
    'login-with-sms-verification': SmsVerification,
    'login-with-wallet-only': LoginView,
    'merge-user-accounts': MergeUserAccountsView,
    'merge-user-accounts-conflicts': MergeUserAccountsConflictsView,
    'merge-user-accounts-with-same-email': MergeUserAccountsWithSameEmailView,
    'mfa-choose-device': MfaChooseDeviceView,
    'mfa-display-backup-codes': MfaDisplayBackupCodesView,
    'mfa-recovery': MfaRecoveryView,
    'mfa-secure-device': MfaSecureDeviceView,
    'mfa-secure-device-help': MfaSecureDeviceHelper,
    'mfa-verification': MfaVerificationView,
    'multi-wallet-wallet-list': WalletList,
    'network-not-supported': NetworkNotSupported,
    'network-not-supported-manual': NetworkNotSupportedSwitchManual,
    'no-access': NoAccess,
    'no-qr-not-installed': NoQrNotInstalledView,
    'passkey-intro': PasskeyIntroView,
    'passkey-new-domain-detected': PasskeyNewDomainDetectedView,
    'passkey-recovery-add-email': AddRecoveryEmail,
    'passkey-recovery-bundle': PasskeyBundleRecovery,
    'passkey-recovery-complete': PasskeyCompleteRecovery,
    'passkey-recovery-start': PasskeyInitRecovery,
    'pending-connect': PendingConnectView,
    'pending-signature': PendingSignatureView,
    'pending-signature-without-back-button': PendingSignatureView,
    'qr-code': QrCodeView,
    'rename-passkey': RenamePasskeyView,
    'sandbox-maximum-threshold-reached': SandboxMaximumThresholdReached,
    'select-hardware-wallet': SelectHardwareWalletView,
    'select-wallet-in-wallet-group': SelectWalletInWalletGroupView,
    'social-redirect-view': SocialRedirectView,
    'social-wrong-account': SocialWrongAccountView,
    'verify-email': EmailVerification,
    'verify-sms': SmsVerification,
    'wait-for-email-confirmation-view': EmailConfirmationWaitingView,
    'wallet-cannot-be-transferred': WalletCannotBeTransferredView,
    'wallet-claim-intro': CoinbaseMPCClaimIntro,
    'wallet-connect-mobile-wallets-list': () => (jsx(WalletList, { isWalletConnectList: true })),
    'wallet-group': WalletGroupView,
    'wallet-list': WalletList,
    'wallet-locked-view': WalletLockedView,
    'wallet-redirect-view': WalletRedirectView,
    'wallet-sign': WalletSignSpinnerView,
    'wallet-used': WalletUsedView,
};

export { viewToComponentMap };
